import { ChangeDetectionStrategy, Component, computed, input, Input, Signal } from '@angular/core';

export type LogoVariant = 'full' | 'icon';

@Component({
  selector: 'app-logo',
  imports: [],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent {
  variant = input<LogoVariant>('full');

  // Logo path constants
  readonly fullLogoSrc = '/assets/images/transend-logo-wide.png';
  readonly fullLogoAlt = 'Transend Logo';
  readonly iconSrc = 'assets/images/transend-logo-icon.png';
  readonly iconAlt = 'Transend Logo';

  // Computed logo attributes
  src = computed(() => (this.variant() === 'icon' ? this.iconSrc : this.fullLogoSrc));
  alt = computed(() => (this.variant() === 'icon' ? this.iconAlt : this.fullLogoAlt));
  imgClass = computed(() => (this.variant() === 'icon' ? 'logo-icon' : 'logo-img'));
}
